import { decodeJwtClaims } from "./jwt";
import { ParsedToken, Session, SessionInfo } from "./Models";

type SessionState = {
  initialized: boolean;
  session: Session;
};

type Listener = () => void;

let state: SessionState = { initialized: false, session: new Session(false) };

const listeners = new Set<Listener>();

function emit() {
  for (const listener of listeners) listener();
}

function setState(next: SessionState) {
  state = next;
  emit();
}

function decodeJwtPayload(token: string): ParsedToken {
  const payload = decodeJwtClaims<{
    sub?: string;
    preferred_username?: string;
    iat?: number;
    exp?: number;
  }>(token);

  if (!payload) throw new Error("Token JWT non valido");

  if (typeof payload.iat !== "number" || typeof payload.exp !== "number")
    throw new Error("Invalid token");

  const username = payload.preferred_username ?? payload.sub ?? "";

  return new ParsedToken(
    username,
    new Date(payload.iat * 1000),
    new Date(payload.exp * 1000)
  );
}

export function subscribe(listener: Listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot(): SessionState {
  return state;
}

export function setAuthentication(token: string, roles: string[], privileges: string[]) {
  try {
    const parsedToken = decodeJwtPayload(token);
    setState({
      initialized: true,
      session: new Session(
        true,
        new SessionInfo(
          parsedToken.username,
          token,
          roles,
          privileges,
          parsedToken.issuedAt,
          parsedToken.expiredAt
        )
      ),
    });
  } catch (error) {
    console.error(error);
    setState({ initialized: true, session: new Session(false) });
  }
}

export function clearAuthentication() {
  setState({ initialized: true, session: new Session(false) });
}
